import Vue from 'vue'
import VueRouter from 'vue-router'
import Dashboard from "@/views/Dashboard";
import Main from "@/components/Layouts/Main";
import {abilityCheck, getUserData, isUserLoggedIn} from "@/helpers/Utils";

Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: { name: 'Dashboard' } },
  {
    path: '/',
    name: 'Main',
    component: Main,
    children: [
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: Dashboard,
        meta: { requiresAuth: true, roles: '*'},
      },
      {
        path: '/members',
        name: 'Members',
        component: () => import(/* webpackChunkName: "members" */ '../views/Members.vue'),
        meta: { requiresAuth: true, roles: 'superadmin|gate_pass', },
      },
      {
        path: '/events',
        name: 'Events',
        component: () => import(/* webpackChunkName: "events" */ '../views/EventV2.vue'),
        meta: { requiresAuth: true, roles: 'superadmin|control_room|customs', },
      },
      {
        path: '/permits',
        name: 'Permits',
        // component: () => import(/* webpackChunkName: "permits" */ '../views/Permits.vue'),
        component: () => import('../components/PermitsLoader.vue'),
        meta: { requiresAuth: true, roles: 'superadmin|memberadmin|member|control_room|customs', },
      },
      {
        path: '/vehicles',
        name: 'Vehicles',
        component: () => import(/* webpackChunkName: "vehicles" */ '../views/Vehicles.vue'),
        meta: { requiresAuth: true, roles: 'superadmin|memberadmin|gate_pass', },
      },
      {
        path: '/retry',
        name: 'Retry',
        component: () => import(/* webpackChunkName: "vehicles" */ '../views/Retry.vue'),
        meta: { requiresAuth: true, roles: 'superadmin', },
      },
      {
        path: '/retry-set-permit',
        name: 'RetrySetPermit',
        component: () => import(/* webpackChunkName: "vehicles" */ '../views/RetrySetPermit.vue'),
        meta: { requiresAuth: true, roles: 'superadmin', },
      },
      {
        path: '/mayday',
        name: 'Mayday',
        component: () => import(/* webpackChunkName: "vehicles" */ '../views/Mayday.vue'),
        meta: { requiresAuth: true, roles: 'superadmin', },
      },
      // {
      //   path: '/schedules',
      //   name: 'Schedule',
      //   component: () => import(/* webpackChunkName: "schedules" */ '../views/Schedules.vue'),
      //   meta: { requiresAuth: false, roles: 'superadmin',},
      // },
      // {
      //   path: '/reports',
      //   name: 'Report',
      //   component: () => import(/* webpackChunkName: "reports" */ '../views/Reports.vue'),
      //   meta: { requiresAuth: true, roles: 'superadmin',},
      // },
      {
        path: '/users',
        name: 'User',
        component: () => import(/* webpackChunkName: "users" */ '../views/Users/UserList.vue'),
        meta: { requiresAuth: true, roles: 'superadmin|memberadmin', },
      },
      {
        path: '/profile',
        name: 'Profile',
        component: () => import(/* webpackChunkName: "profile" */ '../views/Users/Profile.vue'),
        meta: { requiresAuth: true, roles: '*', },
      },
      {
        path: '/bsims',
        name: 'BSIMS',
        component: () => import(/* webpackChunkName: "bsims" */ '../views/BSIMS.vue'),
        meta: { requiresAuth: true, roles: 'superadmin|control_room', },
      },
      {
        path: '/video/:link',
        name: 'Stream',
        component: () => import(/* webpackChunkName: "stream" */  '../views/Stream'),
        meta: { requiresAuth: false,},
      },
    ],
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */  '../views/Login'),
    meta: {redirectIfLoggedIn: true, requiresAuth: false,}
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import(/* webpackChunkName: "register" */  '../views/Register'),
    meta: { redirectIfLoggedIn: false, requiresAuth: false, }
  },
  {
    path: '/error-404',
    name: 'error-404',
    component: () => import('../views/Error404.vue'),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/error-403',
    name: 'error-403',
    component: () => import('../views/Error403.vue'),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '*',
    redirect: { name: 'error-404' },
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn()
  if (!isLoggedIn && to.meta.requiresAuth) {
    return next({ name: 'Login' })
  }
  const user = getUserData();
  if (isLoggedIn && Object.prototype.hasOwnProperty.call(to.meta, 'roles')  && !abilityCheck(user.role, to.meta.roles)) {
    return next({ name: 'error-403' })
  }

  return next()
})

export default router
